import React, { useEffect, useState } from "react";
import { ElementsConsumer, CardElement } from "@stripe/react-stripe-js";
import CardSection from "./CardSection";
import Loader3Orange from "../../general/Loader3Orange";
import { useDispatch, useSelector } from "react-redux";
import {
  addPaymentCard,
  getGettingPaymentSuccess,
  allPaymentCard,
} from "../../store/myquotes";
import { toast } from "react-toastify";
import { getBrokerInformation } from "../../store/broker";
import translations from "../../utils/translations";

export function CheckoutForm(props) {
  const [isLoading, setIsLoading] = useState(false);
  const paymentDetails = useSelector(getGettingPaymentSuccess);
  const dispatch = useDispatch();
  const broker = useSelector(getBrokerInformation);
  const languagepreference = broker.information.languagepreference;
  const translationsBrokerAdmin =
    translations[languagepreference].brokerageAdmin;
  const handlePayment = (data) => {
    setIsLoading(true);
    const token = { token: data };
    dispatch(addPaymentCard(token)).then(() => {
      dispatch(allPaymentCard()).then(() => {
        setIsLoading(false);
      });
      if (paymentDetails) {
        toast.success(paymentDetails.message);
      }
    });
  };
  useEffect(() => {
    if (paymentDetails) {
      dispatch(allPaymentCard());
    }
  }, [dispatch]);
  const handleSubmit = async (event) => {
    event.preventDefault();
    const { stripe, elements } = props;
    if (!stripe || !elements) {
      return;
    }
    const card = elements.getElement(CardElement);
    const result = await stripe.createToken(card);
    if (result.token.id != "") {
      handlePayment(result.token.id);
      //API Calling
    } else if (result.error) {
      console.log(result.error.message);
    } else {
      console.log(result.token);
    }
  };
  return (
    <>
      <div>
        <div style={{ padding: "0 16px" }}></div>
        <form onSubmit={handleSubmit}>
          <CardSection />
          {isLoading ? (
            <div
              style={{
                width: "100%",
              }}
            >
              <Loader3Orange></Loader3Orange>
            </div>
          ) : null}
          <button
            disabled={!props.stripe}
            style={{
              display: "block",
              width: "100%",
              border: "none",
              color: "#fff",
              padding: "10px",
              fontSize: "18px",
              cursor: "pointer",
              backgroundColor: "rgb(234, 143, 96)",
            }}
          >
            {translationsBrokerAdmin.addCard}
          </button>
        </form>
      </div>
    </>
  );
}
export default function InjectedCheckoutForm() {
  return (
    <ElementsConsumer>
      {({ stripe, elements }) => (
        <CheckoutForm stripe={stripe} elements={elements} />
      )}
    </ElementsConsumer>
  );
}
